import React from "react";
import "./Intro.css";

const Hero = () => {
  return (
    <div id="services-intro-container" className="row">
      <div className="mission col-xs-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2 col-lg-8 offset-lg-3 col-xl-7 offset-xl-3 p-5">
        <div id="brand">Custom Service Solutions for Your Business</div>

        <div className="mission">
          Our solutions are designed to help your business get ahead.
        </div>
      </div>
    </div>
  );
};

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Services/Intro/Intro.js